/**
 * Encodes a Unicode string to a Base64 string.
 * This is a workaround for the "Unicode Problem" where btoa() fails on multi-byte characters.
 * @param str The Unicode string to encode.
 * @returns The Base64-encoded string.
 */
export function encodeUnicode(str: string): string {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode(Number('0x' + p1));
    }
  ));
}

/**
 * Decodes a Base64 string that was encoded with encodeUnicode.
 * @param str The Base64-encoded string.
 * @returns The decoded Unicode string.
 */
export function decodeUnicode(str: string): string {
  return decodeURIComponent(atob(str).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}
